const extemporaneousDrugList = [
  "Melatonin Tablet",
];

export default extemporaneousDrugList;